<template>
  <div class="schedule-time">
    <v-layout row wrap>
      <v-flex xs12 hidden-md-and-up>
        <SubHeader>Time</SubHeader>
      </v-flex>

      <v-flex
        v-if="filterDate"
        xs12
        hidden-sm-and-down
        class="schedule-time--header">
        <div class="schedule-time--back">
          <a :class="{ disabled: !prevAvailability }" @click="clickPrevDay" ref="prev-day-button">
            <v-icon>chevron_left</v-icon>
          </a>
        </div>
        <div class="schedule-time--availability">
          <span>Available on {{longDate(filterDate)}}</span>
        </div>
        <div class="schedule-time--forward">
          <a :class="{ disabled: !nextAvailability }" @click="clickNextDay" ref="next-day-button">
            <v-icon>chevron_right</v-icon>
          </a>
        </div>
      </v-flex>

      <v-flex class="schedule-time--notice" xs12>
        <p>Times presented are in the inspector’s local time zone</p>
      </v-flex>

      <template v-if="hasTimeSlots">
        <v-flex
          v-for="timeSlot in filteredTimeslots"
          :key="timeSlot"
          class="time-select"
          xs12
          sm6
          md4>
          <ScheduleFormTimeButton
            :selectedTime="filterTime"
            :time="timeSlot"
            @click="clickTime(timeSlot)" />
        </v-flex>
      </template>
      <template v-else>
        <v-flex xs12>
          <BaseAlert :hg-value="true" hg-type="info" id="no-timeslots-error">
            No times are available on the selected date. Select a different date.
          </BaseAlert>
        </v-flex>
      </template>
    </v-layout>
  </div>
</template>

<script>
import { Components, Mixins } from '@spectorasoftware/homegauge-vue';
import { mapGetters, mapState } from 'vuex';

import SubHeader from '@/components/common/SubHeader.vue';
import ScheduleFormTimeButton from '@/components/ScheduleFormTimeButton.vue';

const { BaseAlert } = Components;
const { DateTime } = Mixins;

export default {
  components: {
    BaseAlert,
    SubHeader,
    ScheduleFormTimeButton,
  },
  mixins: [DateTime],
  computed: {
    ...mapGetters('Schedule', [
      'filteredTimeslots',
      'nextAvailability',
      'prevAvailability',
    ]),
    ...mapState('Schedule', {
      filterDate: state => state.filters.date,
      filterTime: state => state.filters.time,
    }),
    hasTimeSlots() {
      return !!(this.filteredTimeslots && this.filteredTimeslots.length > 0);
    },
  },
  methods: {
    clickNextDay() {
      if (this.nextAvailability) {
        this.$emit('dateForward');
      }
    },
    clickPrevDay() {
      if (this.prevAvailability) {
        this.$emit('dateBack');
      }
    },
    clickTime(payload) {
      this.$emit('update', payload);
    },
    timeSelected(time) {
      return time === this.filterTime ? 'blue' : 'white';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/vars/theme';
@import '../styles/vars/typography';

.time-select {
  padding-left: 10px;
  padding-right: 10px;
}

.schedule-time--header {
  display: flex;
  font-size: 2em;
  margin: 1.95rem 0 0;
  text-align: center;

  > * {
    display: inline-block;
    vertical-align: middle;
  }

  span {
    font-size: 1.286rem;
    font-weight: $typography-weight-bold;
    letter-spacing: 0.08rem;
  }

  .v-icon {
    color: $theme-color-secondary;
    font-size: 2rem;
  }
}

.schedule-time--notice {
  padding: 1rem 0;
  text-align: center;
}

.schedule-time--availability {
  flex: 4;
  align-content: center;
}

.schedule-time--back,
.schedule-time--forward {
  flex: 1;

  &.disabled {
    .v-icon {
      color: $theme-color-gray-light;
    }
  }
}
</style>
